import React, {Fragment, useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";

import axios from "axios";
import clientconfigwebapp, {
    check_login_appbk, empty_bk, Token_get_appbk,NewlineText_bk
} from "../../../clientconfigwebapp";
import {toast, ToastContainer} from "react-toastify";
import Grid from '@mui/material/Grid';
import {
    Icon_User,
    Icon_Location,
    Icon_inventory,
    Icon_Insurance,
    Icon_Packaging_and_label,
    Icon_Quality_Control,
    Icon_Transportation,
    Icon_Customs_formalities,
    Icon_singpro_Authenticated,
    Icon_btn_tiket_singprod,
    Icon_btn_call_singprod,
} from "../../../assets/icones/icones_single_products";
import Sticky from "react-stickynode";
import ProductCard from "../../../components/Card_boxs/ProductCard";


const Section_2 = (props) => {


    return (<Fragment>



        {
            props.products_seller_curent && props.products_seller_curent.length > 0 ? (

                    <div style={{
                        "borderTop": "1px solid rgb(209, 213, 219)",
                        "paddingTop": "15px",
                        "paddingBottom": "10px"
                    }}>

                        <Fragment>

                            <span className={"title_section_desc_single_prod"}> محصولات دیگر {String(props.data_paged_info.seller_first_name) + " " + String(props.data_paged_info.seller_last_name)} </span>


                            <Grid container direction="row" spacing={2} style={{paddingTop: "14px"}}>
                                {


                                    props.products_seller_curent.map((item_post, index) => {


                                        return (

                                            <Grid item lg={2.4} md={2.4} sm={12} xs={12}>
                                                <ProductCard link_to={"product/" + String(item_post.id_post)}
                                                             data_full_curent_item={item_post}/>
                                            </Grid>

                                        )

                                    })

                                }

                            </Grid>

                        </Fragment>
                    </div>


            ) : (
                <Fragment></Fragment>)

        }




    </Fragment>);
}

export default Section_2;
